<template>
  <footer class="site-footer">
    <div class="sf-inner">
      <span class="sf-brand">IdleGuildMaster</span>
      <span class="sf-ver">{{ getTrans('site_version') }}: {{ appVersion }}</span>
    </div>
  </footer>
</template>

<script>
import config from "@/common/config.js";
export default {
  name: "Footer",
  computed: {
    currentLang() {
      return this.$store.state.lan;
    },
    appVersion() {
      // DB(gm_settings.app_version) 값을 우선 표시, 없으면 프론트 상수로 폴백
      return this.$store.state.app_version || config.appVersion;
    },
  },
  methods: {
    getTrans(type) {
      const t = config.trans[type];
      return t ? (t[this.currentLang] || t['kor']) : type;
    },
  },
};
</script>

<style scoped>
.site-footer {
  flex-shrink: 0;
  border-top: 1px solid var(--border-color);
  background: var(--surface-color);
  margin-top: 48px;
}
.sf-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 22px clamp(16px, 3vw, 36px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.sf-brand {
  font-family: var(--font-display), var(--font-body);
  font-weight: 700;
  font-size: 15px;
  letter-spacing: .02em;
  color: var(--accent-strong);
}
.sf-ver {
  font-size: 13px;
  color: var(--muted-text-color);
}
@media (max-width: 480px) {
  .sf-inner { flex-direction: column; align-items: flex-start; gap: 6px; }
}
</style>
